import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useIsBeamerEnabled } from '@omnea-app/fe-legacy/components/layout/wrapper/useIsBeamerEnabled'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { useBeamerUnreadCount } from './useBeamerUnreadCount'

/** Beamer's product updates: whether the org has them, whether any are unread, and opening them. */
export const useProductUpdates = () => {
  const userData = useAuthenticatedUser()
  const isEnabled = useIsBeamerEnabled()
  const { RFX } = useFeatureFlags()
  const { unreadCount, refetchUnreadCount } = useBeamerUnreadCount({ enabled: isEnabled })

  // `user` is read on click: reading it before the session is fully authenticated throws.
  const show = () => {
    const { user } = userData
    if (window.Beamer) {
      window.Beamer.update({
        user_id: user.id,
        user_firstname: user.firstName,
        user_lastname: user.lastName,
        user_email: user.email,
        sourcing_enabled: RFX,
        onclose: refetchUnreadCount,
      })
      window.Beamer.show()
    }
  }

  return { isEnabled, hasUnread: unreadCount > 0, show }
}
